
<div class="show-rules-txt">
    <div class="show-service1">  <h4 >{{'Schedular Rules'|translate}} </h4>   </div><br>
  <div class="show-service">  <h4 >{{serviceName}} </h4>   </div>
<h4 >{{'Scheduled blackout rules'|translate}} </h4>
<table >
    <thead >
      <tr>
        <th> </th>
        <th ></th>
        <th> </th>
      
        
      </tr>
    </thead>
    <tbody >
      <tr *ngFor="let i of editList">
        <td >{{i.description}}</td>
        <td > <button  name="uploadXml" class="show-btn"  (click)="routeToRecur(i)">{{'Edit'|translate}} {{i.recurring}}</button></td>
        <td ><button  name="uploadXml" class="show-btn" (click)="delete(i.id,i.recurring)">{{'Delete Rule'|translate}}</button></td>
       
      
      </tr>
    
    </tbody>
  </table>
  <br>
<!-- <ng-container *ngFor="let i of editList" >
<div ><span class="recur-desc">{{i.description}}</span>&nbsp; &nbsp; &nbsp;&nbsp;                               
    <button  name="uploadXml" class="show-btn" (click)="delete(i.id,i.recurring)">Delete Rule</button><br></div><br>
</ng-container><br> -->

<!-- <ng-container *ngIf="isEditonOff">
    <div *ngFor="let i of oneOffResponseList"><span class="recur-desc">{{i.description}}</span> &nbsp; &nbsp;<input  type="submit" name="uploadXml" class="recur-main-txt" value="Edit a Oneoff Rule" (click)="routeToOnOff(i.serviceid)">&nbsp;&nbsp;
        <input  type="submit" name="uploadXml" class="recur-main-txt" value="Delete Rule" (click)="delete(i.serviceid,i.recurring)"></div>
    </ng-container><br> -->


<p *ngIf="editList.length == 0">{{'No rules have been defined'|translate}}.</p>
<p>{{'There are two kinds of schedular rules'|translate}}:</p>
    <p class="show-rule-p">1.{{'Recurring weekly rule'|translate}}</p>
    <p class="show-rule-p">{{'This type of rule is used every week. It starts at a specific time on a given'|translate}} &nbsp;<button   class="show-btn" name="uploadXml" (click)="recuringRule()">{{'Add a Recurring Rule'|translate}}</button><br> {{'day of the week'|translate}}.</p>
    <p class="show-rule-p">2.{{'Oneoff Rule'|translate}}</p>
    <p class="show-rule-p">{{'A one off scheduler rule starts on a specific calender date and time'|translate}}.&nbsp;&nbsp;&nbsp;<button   class="show-btn" name="uploadXml"  (click)="oneOffRule()">{{'Add a Oneoff Rule'|translate}}</button></p>
</div>
<div class="show-rules-txt">
    <h4 >{{'Manual blackout rules'|translate}} </h4>
    <p>  <input  type="checkbox" class="updateCheck"name="hours" id="hours" [(ngModel)]="isCheck" >&nbsp;&nbsp;<button   class="show-btn" name="uploadXml" (click)="update()">{{'Update'|translate}}</button></p>
    <button   class="show-btn" name="uploadXml" (click)="back()">{{'Back'|translate}}</button>
    </div>
   